var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MainLayout",
    { attrs: { "page-name": "customer-master" } },
    [
      _c(
        "PageHeader",
        { attrs: { title: _vm.title } },
        [
          _c(
            "el-row",
            { staticClass: "header-button" },
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "register",
                      attrs: { type: "primary" },
                      on: { click: _vm.clickRegister }
                    },
                    [_vm._v("新規追加")]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "detail-search",
                      attrs: { type: "primary" },
                      on: { click: _vm.clickDetailSearch }
                    },
                    [_vm._v("詳細検索")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "SimpleSearch",
            {
              attrs: { model: _vm.simpleSearchFormModel },
              on: { search: _vm.clickSearch }
            },
            [
              _c("CustomerCode", {
                attrs: {
                  searchCond: true,
                  "autocomplete-list": _vm.customerCodeSet,
                  initialize: true
                },
                model: {
                  value: _vm.simpleSearchFormModel.customer_code,
                  callback: function($$v) {
                    _vm.$set(_vm.simpleSearchFormModel, "customer_code", $$v)
                  },
                  expression: "simpleSearchFormModel.customer_code"
                }
              }),
              _c("CustomerName", {
                attrs: {
                  searchCond: true,
                  "autocomplete-list": _vm.customerNameSet,
                  initialize: true
                },
                model: {
                  value: _vm.simpleSearchFormModel.customer_name,
                  callback: function($$v) {
                    _vm.$set(_vm.simpleSearchFormModel, "customer_name", $$v)
                  },
                  expression: "simpleSearchFormModel.customer_name"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("Table", {
        attrs: {
          "table-data": _vm.tableData,
          dataFormatter: _vm.csvDataFormatter,
          "default-sort": { prop: "customer_code", order: "ascending" }
        },
        on: { "row-click": _vm.clickRow, "multiple-delete": _vm.deleteRows },
        scopedSlots: _vm._u([
          {
            key: "columns",
            fn: function() {
              return [
                _c("CustomerCodeColumn"),
                _c("CustomerNameColumn"),
                _c("PrivateIdColumn", { attrs: { prop: "private_id_name" } }),
                _c("InvoiceAddressColumn"),
                _c("PostalCodeColumn"),
                _c("StreetAddressColumn"),
                _c("PhoneNumberColumn"),
                _c("MenuColumn", {
                  attrs: { cbdelete: _vm.deleteRow },
                  on: { copy: _vm.copyRow }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("CustomerMasterRegisterDialog", {
        attrs: {
          visible: _vm.registerDialogVisible,
          "autocomplete-customer-code-set": _vm.customerCodeSet,
          "autocomplete-customer-name-set": _vm.customerNameSet,
          "current-row": _vm.currentRow
        },
        on: {
          "update:visible": function($event) {
            _vm.registerDialogVisible = $event
          },
          refresh: _vm.refreshSearch
        }
      }),
      _c("CustomerMasterDetailSearchDialog", {
        attrs: {
          visible: _vm.detailDalogVisible,
          "autocomplete-customer-code-set": _vm.customerCodeSet,
          "autocomplete-customer-name-set": _vm.customerNameSet
        },
        on: {
          "update:visible": function($event) {
            _vm.detailDalogVisible = $event
          },
          search: _vm.detailSearch
        }
      }),
      _c("CustomerMasterEditDialog", {
        attrs: {
          visible: _vm.editDialogVisible,
          "autocomplete-customer-code-set": _vm.customerCodeSet,
          "autocomplete-customer-name-set": _vm.customerNameSet,
          "current-row": _vm.currentRow
        },
        on: {
          "update:visible": function($event) {
            _vm.editDialogVisible = $event
          },
          refresh: _vm.refreshSearch
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }